import { Request } from '@/utils';
import { CarouselBannerType, ApplicationGroupDetailType , FixUrls} from '@/types';

class ProtalInfo extends Request {
	// 获取首页轮播图
	getCarouselBannerList() {
		return this.get<CarouselBannerType[]>({
			url: '/mobile/api/getCarouselBannerList',
		});
	}
	// 获取待我审批的数量
	getPendingApprovalCount() {
		return this.get<number>({
			url: '/mobile/api/getPendingApprovalCount',
		});
	}
	// 获取自助申请模块菜单分组数据
	getApplicationGroupDetailList() {
		return this.get<ApplicationGroupDetailType[]>({
			url: '/mobile/api/getApplicationGroupDetailList',
		});
	}
	// 获取自助申请模块几个固定菜单
	getApplicationFixedUrl() {
		return this.get<FixUrls>({
			url: '/mobile/api/getApplicationFixedUrl',
		});
	}
	// 获取跳取外链菜单所需要的token
	getOutLinkUsedToken() {
		return this.get<string>({
			url: '/mobile/api/getOutLinkUsedToken',
		});
	}

	// 获取今日打卡数量
	getTodayCount() {
		return this.get<Array<string>>({
			url: '/mobile/attendance/check-in/today'
		});
	}

	// 获取今日打卡数量
	getYesterdayCount() {
		return this.get<Array<string>>({
			url: '/mobile/attendance/check-in/yesterday'
		});
	}

}

export const ProtalInfoApi = new ProtalInfo();
